// extracted by mini-css-extract-plugin
export default {"categoryDialogueBox":"CategoryCheckBox_categoryDialogueBox__aIQAs","checkbox":"CategoryCheckBox_checkbox__uITre","checkboxTitle":"CategoryCheckBox_checkboxTitle__eUMLz"};